var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1251_943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H45V45H5V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1251_943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7326 12.5529C38.7563 13.5292 37.1734 13.5292 36.1971 12.5529C35.2208 11.5766 35.2208 9.99369 36.1971 9.01736C37.1734 8.04104 38.7563 8.04104 39.7326 9.01736C40.709 9.99369 40.709 11.5766 39.7326 12.5529Z",
    stroke: "#0095DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8029 40.9826C12.8266 41.9589 11.2437 41.9589 10.2674 40.9826C9.29107 40.0063 9.29107 38.4234 10.2674 37.4471C11.2437 36.4707 12.8266 36.4707 13.8029 37.4471C14.7793 38.4234 14.7793 40.0063 13.8029 40.9826Z",
    stroke: "#0095DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.21 43.8451C22.4579 44.0942 23.7275 44.2194 25 44.2187C35.6143 44.2187 44.2188 35.6142 44.2188 25C44.2188 20.3665 42.5788 16.1162 39.8479 12.7972",
    stroke: "#0095DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8266 6.16258C27.5669 5.90855 26.285 5.78091 25 5.78156C14.3858 5.78156 5.78125 14.3861 5.78125 25.0003C5.78125 29.6338 7.42125 33.8841 10.1521 37.2031",
    stroke: "#0095DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9994 30.6742C21.8656 30.6742 19.3252 28.1338 19.3252 25C19.3252 21.8663 21.8656 19.3259 24.9994 19.3259C28.1331 19.3259 30.6736 21.8663 30.6736 25C30.6736 28.1338 28.1331 30.6742 24.9994 30.6742ZM36.3146 22.5505C36.0218 21.1879 35.4839 19.8898 34.7271 18.7195L36.224 17.2225L32.7686 13.7696L31.2729 15.2653C30.1026 14.5085 28.8045 13.9706 27.4419 13.6779V11.5625H22.5569V13.6779C21.1943 13.9706 19.8962 14.5085 18.7259 15.2653L17.2302 13.7696L13.7748 17.2225L15.2716 18.7195C14.5148 19.8898 13.977 21.1879 13.6841 22.5505H11.5632L11.5605 27.4355H13.6841C13.9769 28.7981 14.5148 30.0962 15.2716 31.2666L13.769 32.7692L17.2219 36.2247L18.7257 34.7208C19.8961 35.4776 21.1942 36.0155 22.5569 36.3084V38.4375H27.4419V36.3084C28.8045 36.0155 30.1027 35.4776 31.273 34.7208L32.7769 36.2247L36.2298 32.7692L34.7272 31.2666C35.484 30.0962 36.0219 28.7981 36.3147 27.4355H38.4382V22.5505H36.3146Z",
    stroke: "#0095DF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.9a4184d8d7a6ae54ed360cd448990e68.svg";
export { ForwardRef as ReactComponent };